export default "__VITE_ASSET__A6Com3nV__"